// Hook to get Global state for trading
import { useDispatch, useSelector } from 'react-redux';
import { actionCreateNotification } from '../../../actions/notifications';
import { IStore } from '../../../reducers';

const useAppState = () => {
  const current = useSelector((state: IStore) => state.current);
  const globalDispatch = useDispatch();
  const onNotify = (args: any) =>
    globalDispatch(actionCreateNotification(args));

  return {
    current,
    onNotify,
    globalDispatch,
  };
};

export default useAppState;
